import { ActionBehavior, HorizontalPosition } from '../../utils/action-utils';
import { ButtonType } from '../../utils/button';
import { CrudTableViewConfig, CrudViewColumnType } from '../../utils/list-grid';

export const DATA_FIELD_SIMPLE_DISPLAY_LIST_CONFIG: CrudTableViewConfig = {
  defaultSearchField: 'name',
  showPagination: false,
  orderable: false,
  sortable: false,
  searchable: false,
  filterable: false,
  columns: [
    {
      title: 'Name',
      fieldName: 'name',
      type: CrudViewColumnType.Text
    },
    {
      title: 'Type',
      fieldName: 'type',
      type: CrudViewColumnType.Text
    },
    {
      title: 'Description',
      fieldName: 'description',
      type: CrudViewColumnType.Text
    }
  ],
  listActions: [
    // {
    //   name: 'editDataFields',
    //   text: 'Edit Data Model and Fields',
    //   buttonType: ButtonType.Default,
    //   behavior: ActionBehavior.Emit,
    //   icon: { name: 'fa-regular fa-pencil-alt' },
    //   horizontalPosition: HorizontalPosition.Right,
    // }
  ],
  itemActions: [],
  handleVisibilityFn: (data, item, action) => {
    if (item.isUpdatable && action.name === 'edit') {
      return true;
    }

    if (item.isDeletable && action.name === 'DELETE_ITEM') {
      return true;
    }
  }
};
